import { Component, OnInit } from '@angular/core';
import { OrganizationSetupCommon } from '../organization-setup.common';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-standard-rates',
  templateUrl: './standard-rates.component.html',
  styleUrls: ['./standard-rates.component.css']
})
export class StandardRatesComponent implements OnInit {
  selectYear: any;
  selectedBranch: any;
  roleList: any;
  branchList: any;
  financialYearList: any;
  serviceVerticalList: any;

  modalFormObjList: any;
  modalForm: any;
  modalStatus: any;
  formSubmitted = false;
  formErrors = OrganizationSetupCommon.standardRateFormErrors;
  formValidationMessages = OrganizationSetupCommon.standardRateFormValidationMessages;

  decimalRegex = /^-?\d*[.,]?\d{0,2}$/
  selectedRole = " ";
  selectedServiceVertical = " ";

  constructor(private organizationSetupService: OrganizationSetupService,
    private masterDataService: MasterDataService,
    private fb: FormBuilder, private modalService: NgbModal,
    private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.initModalForm();
    this.loadBranch();
    this.loadRoles();
    this.loadServiceVerticals();
    this.modalForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.modalForm);
    });
    this.modalForm.get('role')?.valueChanges.subscribe((role) => {
      this.onRoleChange(role);
    });
  }

  disableButtons: boolean;
  loadStandardRates() {
    console.log('selected branch', this.selectedBranch);
    console.log('selected year', this.selectYear);
    if (this.selectYear.id < 10) {
      this.disableButtons = true;
    } else {
      this.disableButtons = false;
    }

    if (this.selectedBranch == 'Select' || this.selectYear == 'Select') {
      this.commonMessageService.swalAlertWithoutIcon('','Select values in both field')
    } else {
      this.organizationSetupService.getStandardRates(this.selectYear.id, this.selectedBranch.id)
        .subscribe(res => {
          console.log(res);
          this.modalFormObjList = res;
          //this.loadRoles();
        });
    }
  }

  loadRoles() {
    this.masterDataService.getRoles()
      .subscribe(res => {
        console.log(res);
        this.roleList = res;
      });
  }

  loadBranch() {
    this.masterDataService.getBranch()
      .subscribe((res: any) => {

        this.branchList = res;

        var branchIndex = -1;
        this.branchList.forEach((element, key) => {
          if (element.name == 'Pune') {
            branchIndex = key;
          }
        });
        this.selectedBranch = this.branchList[branchIndex];
        console.log("this.selectedBranch", this.selectedBranch)
        this.loadFinancialYear();
        // this.loadStandardRates();
      });
  }

  loadFinancialYear() {
    this.masterDataService.getFinancialYear()
      .subscribe(res => {
        console.log(res);
        this.financialYearList = res;

        var fyIndex = -1;
        this.financialYearList.forEach((element, key) => {
          var startDate = new Date(element.startDate);
          var endDate = new Date(element.endDate);
          // var currentDate = new Date();
          var currentDate = moment(new Date()).format('YYYY-MM-DD');
          if (
            currentDate >= element.startDate &&
            currentDate <= element.endDate
          ) {
            fyIndex = key;
          }
        });
        this.selectYear = this.financialYearList[fyIndex];
        console.log("this.selectYear", this.selectYear)
        this.loadStandardRates();
      });


  }

  loadServiceVerticals() {
    this.masterDataService.getServiceVerticalList()
    .subscribe(res => {
      console.log('verticals :', res);
      this.serviceVerticalList = res;
    })
  }

  initModalForm() {
    this.modalForm = this.fb.group({
      id: [''],
      financialYear: ['', [Validators.required]],
      branch: ['', [Validators.required]],
      role: ['', [Validators.required]],
      serviceVertical: ['', [Validators.required]],
      rate: ['', [Validators.required, Validators.pattern(this.decimalRegex)]],
    });
  }

  // Modal Code
  openModal(content, status) {
    this.modalStatus = status;
    if (!(this.modalStatus == 'edit')) {
      this.resetModalForm();
    }
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'md', windowClass: "animate__animated animate__slideInUp animate__faster" }).result.then((result) => {
    }, (reason) => {
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  resetModalForm() {
    this.formSubmitted = false;
    this.modalForm.reset();
  }

  //----------------------

  onDeleteClick(item) {
    console.log(item);
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor:'#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.modalStatus = 'delete';
         this.organizationSetupService.deleteStandardRate(item.id)
        .subscribe(resp => {
           console.log(resp);
          this.changeModalFormObjList(item);
        this.commonMessageService.swalAlertWithIcon('','Deleted Successfully!','success');
      })
      }
    })
    
  }

  onSaveClick() {
    console.log(this.modalForm);
    this.formSubmitted = true;
    this.logValidationErrors(this.modalForm);
    if (this.modalForm.valid) {
      this.organizationSetupService.saveStandardRate(this.modalForm.value)
        .subscribe(resp => {
          console.log(resp);
          this.closeModal();
          this.changeModalFormObjList(resp);
            this.commonMessageService.swalAlertWithIcon('','Saved Successfully!','success');
        })
    }
  }

  compareById = (o1: any, o2: any): boolean => {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  };

  onRoleChange(role: any) {
    const serviceVerticalControl = this.modalForm.get('serviceVertical');

    if (role?.name === 'Article') {
      serviceVerticalControl?.disable();
      serviceVerticalControl?.reset(null);
    } else {
      serviceVerticalControl?.enable();
      serviceVerticalControl?.reset(null);
    }
  }

  // ----------------------------
  limitDecimal(event) {
    const e_val: string = event.target.value
    console.log('Change: ', e_val)

    if (!this.decimalRegex.test(e_val)) {
      console.log('Eval', e_val)
      event.target.value = Number(e_val).toFixed(2)
    }
  }

  setValueToModalForm(modalObj) {
    console.log(modalObj);
    const roleIndex = this.roleList.findIndex(item => item.id == modalObj.role.id);
    const fyIndex = this.financialYearList.findIndex(item => item.id == modalObj.financialYear.id);
    const branchIndex = this.branchList.findIndex(item => item.id == modalObj.branch.id);
    const verticalIndex = this.serviceVerticalList.findIndex(item => item.id == modalObj?.serviceVertical?.id);
    this.modalForm.patchValue({
      id: modalObj.id,
      role: this.roleList[roleIndex],
      serviceVertical: this.serviceVerticalList[verticalIndex],
      financialYear: this.financialYearList[fyIndex],
      branch: this.branchList[branchIndex],
      rate: modalObj.rate,
    });
  }

  viewModalFormObj(formObj, content) {
    this.organizationSetupService.viewStandardRate(formObj.id)
      .subscribe(resp => {
        this.setValueToModalForm(resp);
        this.openModal(content, 'edit');
      })
  }

  onEditClick(modalContent, formObj) {
    console.log(formObj);
    // this.viewModalFormObj(formObj,modalContent);
    this.setValueToModalForm(formObj);
    this.openModal(modalContent, 'edit');
  }

  onUpdateClick() {
    console.log(this.modalForm);
    console.log(this.modalForm.value);
    this.formSubmitted = true;
    this.logValidationErrors(this.modalForm);
    if (this.modalForm.valid) {
      this.organizationSetupService.updateStandardRate(this.modalForm.value)
        .subscribe(resp => {
          console.log(resp);
          this.changeModalFormObjList(resp);
          this.closeModal();
            this.commonMessageService.swalAlertWithIcon('','Updated Successfully!','success');

        })
    }
  }

  //Setting
  changeModalFormObjList(modalFormObj) {
    if (this.modalStatus == 'add') {
      this.modalFormObjList.push(modalFormObj);
    }
    if (this.modalStatus == 'edit') {
      var index = this.modalFormObjList.findIndex(item => item.id === modalFormObj.id)
      this.modalFormObjList.splice(index, 1, modalFormObj);
    }
    if (this.modalStatus == 'delete') {
      var index = this.modalFormObjList.findIndex(item => item.id === modalFormObj.id)
      this.modalFormObjList.splice(index, 1);
    }
  }



  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        console.log('Key = ' + key + ' && Value = ' + abstractControl.value);
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            console.log(errorKey)
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

}
